module.exports = __webpack_public_path__ + "static/media/blog2.bc553823.jpg";